import { MAX_STEP, MIN_STEP } from "@/constants/dataset";

/**
 * Calculates the maximum step value based on total rows.
 */
export const getMaxStepValue = (totalRows: number): number =>
  totalRows >= 10 ? MAX_STEP : totalRows;

/**
 * Calculates the default step value based on total rows.
 * - totalRows < 2  → MIN_STEP
 * - totalRows < 10 → totalRows
 * - totalRows >= 10 → MAX_STEP
 */
export const computeStepValue = (totalRows: number): number => {
  if (totalRows < 2) return MIN_STEP;
  if (totalRows < 10) return totalRows;
  return MAX_STEP;
};

/**
 * Clamps and normalizes user input for the step value.
 * Handles edge cases such as leading zeros and values exceeding the max.
 */
export const clampStepValue = (
  rawValue: string,
  maxStepValue: number
): number | null => {
  const numericValue = Number.parseInt(rawValue, 10);

  if (Number.isNaN(numericValue)) return null;

  let result = numericValue;

  if (result > maxStepValue) {
    if (rawValue.length > 1) {
      const lastDigit = Number(rawValue.slice(-1));
      result =
        lastDigit < MIN_STEP ? maxStepValue : Math.min(maxStepValue, lastDigit);
    } else {
      result = maxStepValue;
    }
  }

  if (result < MIN_STEP) {
    result = MIN_STEP;
  }

  return result;
};
